import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const esParaVos = ['Querés aprender desde cero', 'Querés emprender o generar ingresos extra', 'Te gustan las manualidades y la decoración', 'Tenés poco tiempo y necesitás aprender a tu ritmo', 'Sos mamá, estudiante, ama de casa o trabajadora'];
const noEsParaVos = ['Buscás algo teórico sin práctica', 'Ya sos decoradora profesional avanzada', 'No tenés ganas de practicar en casa', 'Esperás resultados sin esfuerzo'];
export function ParaQuien() {
  return <section className="w-full bg-white py-24" data-id="element-112" data-mp="qriinmumvyrn">
      <div className="mx-auto max-w-5xl px-6" data-id="element-113" data-mp="lt78tc4c9o9f">
        <Reveal data-id="element-114" data-mp="lw3bfdr4t147">
          <h2 className="font-display text-center text-3xl font-semibold text-[#2f2a33] sm:text-4xl" data-id="element-115" data-mp="hsx4s503x7x7">
            Este curso es para vos si...
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-6 md:grid-cols-2" data-id="element-116" data-mp="36i4tmir3fkdy">
          <Reveal data-id="element-117" data-mp="32i32h3izi9cx">
            <div className="h-full rounded-3xl border-2 border-[#ec4899]/25 bg-[#fdf2f8] p-8" data-id="element-118" data-mp="32hkvbbusaaq8">
              <h3 className="flex items-center gap-2 text-lg font-semibold text-[#db2777]" data-id="element-119" data-mp="3t4hkox7w5fzp">
                <span className="grid h-8 w-8 place-items-center rounded-full bg-[#ec4899] text-white" data-id="element-120" data-mp="1wvbyq6benbz">
                  <CheckIcon className="h-5 w-5" data-id="element-121" data-mp="3k2qg5vp37f7f" />
                </span>
                Es para vos
              </h3>
              <ul className="mt-6 space-y-4" data-id="element-122" data-mp="3o6g2eeiahkpa">
                {esParaVos.map((t, i) => <li key={i} className="flex items-start gap-3 text-[#2f2a33]/85" data-id="element-123" data-mp="3ab3vz9uru5sj" data-mpi={i}>
                    <CheckIcon className="mt-1 h-5 w-5 shrink-0 text-[#ec4899]" data-id="element-124" data-mp="3f5hyrxbrjf78" />
                    {t}
                  </li>)}
              </ul>
            </div>
          </Reveal>

          <Reveal delay={0.08} data-id="element-125" data-mp="35edhgqym7i98">
            <div className="h-full rounded-3xl border-2 border-[#2f2a33]/10 bg-[#f7f7f8] p-8" data-id="element-126" data-mp="2recff86m64s6">
              <h3 className="flex items-center gap-2 text-lg font-semibold text-[#2f2a33]/70" data-id="element-127" data-mp="2wdfn70dzap3u">
                <span className="grid h-8 w-8 place-items-center rounded-full bg-[#2f2a33]/70 text-white" data-id="element-128" data-mp="2wf8mtvq6c92c">
                  <XIcon className="h-5 w-5" data-id="element-129" data-mp="x6h28js1nt3r" />
                </span>
                No es para vos
              </h3>
              <ul className="mt-6 space-y-4" data-id="element-130" data-mp="s6w2i751vgpz">
                {noEsParaVos.map((t, i) => <li key={i} className="flex items-start gap-3 text-[#2f2a33]/60" data-id="element-131" data-mp="o6c5r4oe2f4d" data-mpi={i}>
                    <XIcon className="mt-1 h-5 w-5 shrink-0 text-[#2f2a33]/40" data-id="element-132" data-mp="1kw2wcstk7i4w" />
                    {t}
                  </li>)}
              </ul>
            </div>
          </Reveal>
        </div>
      </div>
    </section>;
}